import { isPlainObject } from 'lodash';
export function isArray(data) {
    return Array.isArray(data);
}
export function notEmptyObject(value) {
    return isPlainObject(value) && Object.keys(value).length;
}
export function isEmpty(value) {
    if (Array.isArray(value) && value.length === 0) {
        return true;
    }
    if (isPlainObject(value) && Object.keys(value).length === 0) {
        return true;
    }
    return [null, undefined, '', NaN].includes(value);
}
// 查询url后传递的字符串参数 json
export var getUrlParams = function (urlSearch, config) {
    var urlSearchList = urlSearch && /\?.*/.exec(urlSearch);
    urlSearch = (urlSearchList && urlSearchList[0]) || location.search;
    // 取得查询字符串并去掉开头的问号，location.search返回?以后的字符串
    if (urlSearch.indexOf('?') !== -1) {
        urlSearch = urlSearch.slice(1);
    }
    var queryString = urlSearch.length ? urlSearch : '';
    var result = {};
    var items = queryString.length ? queryString.split('&') : [];
    // 逐个将每一项添加到args对象中
    items.forEach(function (item) {
        item = item.split('=');
        // url后的参数浏览器会对其进行编码（encodeURIComponent），此处进行解码操作。
        var name = window.decodeURIComponent(item[0]);
        var value = window.decodeURIComponent(item[1]);
        if (name && name.length && !result[name]) {
            // 判断是否需要对URL中的布尔值进行转换
            if (config === null || config === void 0 ? void 0 : config.decodeBool) {
                if (value === 'true')
                    value = true;
                if (value === 'false')
                    value = false;
            }
            // 避免重复参数被覆盖
            result[name] = value;
        }
    });
    return result;
};
